import { render, staticRenderFns } from "./SimulationInfoModal.vue?vue&type=template&id=35e3b20f&"
import script from "./SimulationInfoModal.vue?vue&type=script&lang=js&"
export * from "./SimulationInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./SimulationInfoModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports